module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_13_EQ.6209623c.png";